import api, { AUTH_TOKEN_STORAGE_KEY } from '../api/config';
import { armPersistence, clearPersistedQueryCache } from '../providers/queryClient';

export const isAuthenticated = async (): Promise<any> => {
    const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
    if (token) {
        try {
            const response = await api.get('/user/verify');
            if ([200, 201].includes(response.status)) {
                return response.data.user;
            }
        } catch (err) {
            clearUserData();
        }
    }
    return false;
};

export const setUserData = (token: string): void => {
    localStorage.setItem(AUTH_TOKEN_STORAGE_KEY, token);
    armPersistence();
};

export const clearUserData = (): void => {
    localStorage.removeItem(AUTH_TOKEN_STORAGE_KEY);
    // The signed-out session must not leave its rows in localStorage.
    clearPersistedQueryCache();
};
